<template>
    <div class="w-full px-12 mt-48 xs:w-1/2 sm:w-1/3">
        <!--    CARD START-->
        <div>
            <div class="flex items-center">
                <div class="flex items-center justify-center flex-shrink-0 w-48 h-48 bg-yellow-200 rounded-full">
                    <div class="flex-shrink-0 block w-24 h-24 fill-current text-primary">
                        <IconNotesSVG class="w-24 h-24" />
                    </div>
                </div>

                <span class="ml-12 font-normal title-lg text-primary">{{ $t('info.org_info') }}</span>
            </div>

            <span v-if="customerInfo.companyname" class="mt-16 self-label">{{ $t('info.company_name') }}</span>
            <span v-if="customerInfo.companyname" class="text-base font-semibold sm:text-md">{{ customerInfo.companyname }}</span>

            <span v-if="customerInfo.addresses[0] && customerInfo.addresses[0].country_name" class="mt-16 self-label">{{
                $t('info.country_of_residence')
            }}</span>
            <span v-if="customerInfo.addresses[0] && customerInfo.addresses[0].country_name" class="text-base font-semibold sm:text-md">{{
                customerInfo.addresses[0].country_name
            }}</span>

            <span v-if="customerInfo.registration_code" class="mt-16 self-label">{{ $t('info.registration_code') }}</span>
            <span v-if="customerInfo.registration_code" class="text-base font-semibold sm:text-md">{{
                customerInfo.registration_code
            }}</span>

            <span v-if="customerInfo.vat_code" class="mt-16 self-label">{{ $t('info.vat_number') }}</span>
            <span v-if="customerInfo.vat_code" class="text-base font-semibold sm:text-md">{{ customerInfo.vat_code }}</span>

            <button v-if="customerInfo.customertype === 'P'" @click="openModal('company_data_modal')" class="mt-16 self-btn-plain">
                <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
                    <IconPencilSVG />
                </span>
                <span class="self-btn-plain__text">{{ $t('info.modify') }}</span>
            </button>
        </div>
        <!--    CARD END-->

        <!--     MODAL START-->
        <div class="micromodal" id="company_data_modal" aria-hidden="true">
            <div class="px-10 micromodal__overlay" tabindex="-1">
                <div class="micromodal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                    <header class="micromodal__header">
                        <h2 class="pb-24 pr-48 title-2xl text-primary">{{ $t('info.edit_org_info') }}</h2>

                        <button class="micromodal__close" aria-label="Close modal" data-micromodal-close>
                            <span class="flex-shrink-0 block w-20 h-20 text-black pointer-events-none fill-current">
                                <IconXSVG />
                            </span>
                        </button>
                    </header>
                    <div class="micromodal__content">
                        <div class="flex self-form-wrap">
                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="ettevotte_nimi">{{ $t('info.company_name') }}</label>
                                <div class="relative">
                                    <input
                                        type="text"
                                        id="ettevotte_nimi"
                                        placeholder=""
                                        name="ettevotte_nimi"
                                        value="OÜ Viljar ja Pojad"
                                        disabled
                                        class="e5-input"
                                    />
                                </div>
                            </div>

                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="asukohariik">{{ $t('info.country_of_residence') }}</label>
                                <div class="relative">
                                    <input type="text" id="asukohariik" placeholder="" name="asukohariik" value="Eesti" class="e5-input" />
                                </div>
                            </div>

                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="registrikood">{{ $t('info.registration_code') }}</label>
                                <div class="relative">
                                    <input
                                        type="text"
                                        id="registrikood"
                                        placeholder=""
                                        name="registrikood"
                                        value="E123124124"
                                        class="e5-input"
                                    />
                                </div>
                            </div>

                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="kmkr">{{ $t('info.vat_number') }}</label>
                                <div class="relative">
                                    <input type="text" id="kmkr" placeholder="" name="kmkr" value="EE9018241231" class="e5-input" />
                                </div>
                            </div>

                            <div class="flex items-center justify-between w-full px-8 pt-16">
                                <div>
                                    <button class="self-btn-primary">
                                        {{ $t('info.save') }}

                                        <span class="text-yellow-300 self-btn-primary__icon">
                                            <IconArrowAltSVG />
                                        </span>
                                    </button>
                                </div>

                                <div>
                                    <button data-micromodal-close="" class="self-btn-plain">
                                        <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
                                            <IconXSVG />
                                        </span>
                                        <span class="self-btn-plain__text">{{ $t('info.cancel') }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--    MODAL END-->
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import IconNotesSVG from '@/assets/static/icons-src/icon-notes.svg';
import IconPencilSVG from '@/assets/static/icons-src/icon-pencil.svg';
import IconXSVG from '@/assets/static/icons-src/icon-x.svg';
import IconArrowAltSVG from '@/assets/static/icons-src/icon-arrow-alt.svg';
import { ICustomer } from '@/domain/ICustomer';
import UtilsMixin from '@/scripts/utils';

@Component({
    components: {
        IconNotesSVG,
        IconPencilSVG,
        IconXSVG,
        IconArrowAltSVG
    },
    mixins: [UtilsMixin]
})
export default class CompanyData extends Vue {
    get customerInfo(): ICustomer {
        return this.$store.getters.getCustomerInfo;
    }
}
</script>

<style scoped></style>
